module.exports = __webpack_public_path__ + "static/media/bombapscinabgp.15907ad5.png";